import { render, staticRenderFns } from "./PasswordSms.vue?vue&type=template&id=387c1d99&"
import script from "./PasswordSms.vue?vue&type=script&lang=js&"
export * from "./PasswordSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports